import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { AuditTrailSearchService } from '../audit-trail-search/audit-trail-search.service';
import { AppUtils } from '../../utlis/app-utils';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { AuditTrailSearchComponent } from '../audit-trail-search/audit-trail-search.component';

@Component({
  selector: 'dl-notification-audit-trail',
   standalone: true,
     imports: [OneWebComponentsAngularModule,CommonModule,AuditTrailSearchComponent],
  templateUrl: './notification-audit-trail.component.html',
  styleUrl: './notification-audit-trail.component.scss'
})
export class NotificationAuditTrailComponent {
  @Input() inputData: any;
  @Output() closed = new EventEmitter<void>();
  private _liveAnnouncer;
  public initPageLoad = true;
  public displayedColumns = ['timestamp','modifiedBy','role','propertyName','oldValue','newValue'];
  public dataSource;
  public originalDataSource; // Store original unfiltered data
  public flag: boolean = false;

  // Pagination properties
  public pageSize = 10;
  public currentPage = 0;
  public pagedData = [];
  public totalPages = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputData'] && changes['inputData'].currentValue) {
      const data = changes['inputData'].currentValue;
      if (Array.isArray(data?.tableData)) {
        this.originalDataSource = [...data.tableData]; // Store original data
        this.dataSource = [...data.tableData];
      }
      else if (Array.isArray(data)) {
        this.originalDataSource = [...data]; // Store original data
        this.dataSource = [...data];
      }
      else {
        this.originalDataSource = [];
        this.dataSource = [];
      }
      this.setupPagination();
    
    }
  }

  setupPagination() {
    if (!Array.isArray(this.dataSource)) {
      this.pagedData = [];
      this.totalPages = 0;
      return;
    }
    this.totalPages = Math.ceil(this.dataSource.length / this.pageSize);
    this.currentPage = 0;
    this.updatePagedData();
  }

  updatePagedData() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.pagedData = this.dataSource.slice(start, end);
  }

  goToPage(page: number) {
    if (page < 0 || page >= this.totalPages) return;
    this.currentPage = page;
    this.updatePagedData();
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  // Standardized pagination methods
  goToFirstPage(): void {
    this.currentPage = 0;
    this.updatePagedData();
  }

  goToLastPage(): void {
    this.currentPage = this.totalPages - 1;
    this.updatePagedData();
  }

  goToPreviousPage(): void {
    this.prevPage();
  }

  goToNextPage(): void {
    this.nextPage();
  }

  // Add missing pagination properties
  pageSizeOptions = [10, 25, 50, 100];

  get totalCount(): number {
    return this.dataSource?.length || 0;
  }

  get startIndex(): number {
    return this.currentPage * this.pageSize + 1;
  }

  get endIndex(): number {
    const end = (this.currentPage + 1) * this.pageSize;
    return Math.min(end, this.totalCount);
  }

  onPageSizeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.pageSize = parseInt(target.value, 10);
    this.currentPage = 0;
    this.setupPagination();
  }

  
  public constructor(
    public auditTrailSearchService: AuditTrailSearchService, 
    public changeDetectorRef: ChangeDetectorRef,
    public appUtils: AppUtils,
    _liveAnnouncer:LiveAnnouncer
  ) {
    // this.dataSource= (data.tableData);
  }

  

  public closeClicked() {
    this.closed.emit();
  }

  

  ngOnInit(): void {
    this.auditTrailSearchService.searchData$.subscribe(searchValue => {
      // Filtering logic for custom pagination
      if (Array.isArray(this.originalDataSource)) {
        const filter = searchValue.toLowerCase();
        
        if (filter === '' || filter.length === 0) {
          // If search is empty, restore original data
          this.dataSource = [...this.originalDataSource];
        } else {
          // Filter from original data, not already filtered data
          this.dataSource = this.originalDataSource.filter((data: any) => {
            return this.appUtils.getLowerCase(data.timestamp).includes(filter)
              || this.appUtils.getLowerCase(data.modifiedBy).includes(filter)
              || this.appUtils.getLowerCase(data.role).includes(filter)
              || this.appUtils.getLowerCase(data.propertyName).includes(filter)
              || this.appUtils.getLowerCase(data.oldValue).includes(filter)
              || this.appUtils.getLowerCase(data.newValue).includes(filter);
          });
        }
        this.setupPagination();
      }
      this.changeDetectorRef.detectChanges();
    });
  }
  
  isString(input){
    if(typeof input==='string' || typeof input==='boolean' || input===''){
      return true;
    }
    return false;
  }

  toJSON(input){
    return JSON.stringify(input,null,4)
  }


  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  // announceSortChange(sortState: Sort) {
  //   if (sortState.direction) {
  //     this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
  //   } else {
  //     this._liveAnnouncer.announce('Sorting cleared');
  //   }
  // }
}

